import { useInfiniteQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { getNextPageParamFromPaginatedResult } from '@/api/infiniteQueries';
import keyFactory from '@/api/queries/customers/keyFactory';
import { graphql } from '@/gql';
import { GetScheduledEventsForCustomerInput } from '@/gql/graphql';
import { PAGINATION_ARG_DEFAULTS } from '@payaca/shared-isomorphic/constants/graphql-pagination';

const GetCustomerEventsQuery = graphql(`
  query GetCustomerEvents(
    $customerId: ID!
    $pagination: PaginationInput!
    $input: GetScheduledEventsForCustomerInput
  ) {
    customer(id: $customerId) {
      events(input: $input, pagination: $pagination) {
        items {
          id
          name
          beginAt
          endAt
        }
        limit
        offset
        totalCount
      }
    }
  }
`);

const useGetCustomerEvents = (
  customerId?: string,
  input?: GetScheduledEventsForCustomerInput
) => {
  const queryFn = ({ pageParam }: { pageParam: number }) => {
    return gqlClient.request(GetCustomerEventsQuery, {
      customerId: customerId!,
      input,
      pagination: {
        offset: pageParam,
        limit: PAGINATION_ARG_DEFAULTS.limit,
      },
    });
  };

  return useInfiniteQuery({
    enabled: !!customerId,
    queryKey: keyFactory.customerEvents(customerId!, input),
    initialPageParam: PAGINATION_ARG_DEFAULTS.offset,
    queryFn,
    getNextPageParam: getNextPageParamFromPaginatedResult(
      (lastPage) => lastPage.customer.events
    ),
  });
};

export default useGetCustomerEvents;
